import { render, staticRenderFns } from "./GroupManagement.vue?vue&type=template&id=7abe7863"
import script from "./GroupManagement.vue?vue&type=script&lang=ts"
export * from "./GroupManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports